const PAYMENT_URL = 'https://automedsystems.com.au/fdg/callerid/initiate_checkout_tyro';

interface UsePaymentsProps {
  params: {
    req: string;
    kiosk: string;
    pname: string;
    pid: string;
    pmethod: string;
    lid: string;
    did: string;
    aptypeid: string;
    bid: string;
    mac: string;
    room_name: string;
    fees: string;
  };
}

export const usePayments = ({
  params,
}: UsePaymentsProps) => {

  const generatePaymentUrl = () => {
    const urlParams = new URLSearchParams(params);
    return `${PAYMENT_URL}?${urlParams.toString()}`;
  };

  return {
    generatePaymentUrl,
  };
};
